import {newDamage} from '../store'

var dataURLtoBlob = require('blueimp-canvas-to-blob/js/canvas-to-blob.js')
const mixin = {
	data: () => {
		return {
			files: [],
			validate: false,
			newComment: '',
			//opqFleetpartners: [],
			damageTypes: [
				'Lakkskade',
				'Bulk',
				'Kantkjørte felger',
				'Ruteskader',
				'Interiørskader',
				'Slitte frontlykter',
				'Annet'
			],
			damageOfferTexts: [
				'Denne skaden er dessverre for stor til å prises online og må vurderes fysisk på verkstedet for å finne den mest effektive reparasjonsmetoden.',
				'Denne skaden har dessverre rust og rust lar seg dessverre ikke prises online. Rust er svært lunefullt og må sjekkes fysisk slik at man får avdekket omfanget.',
				'Steinsprut er best å vurdere på verkstedet da de kan variere i størrelse og omfang. Typisk koster det kr 500 inkl mva å "pensle" et panser eller et annet panel.'
			],
			offerText: null,
			offerTexts: [
				{
					send_offer: 1,
					title: "Når alle skader er priset",
					text: "Hei {{Navn}} - dette skal vi hjelpe deg med!\nVi har nå gått igjennom dine skader og gitt deg et pristilbud.\n\nDersom du ønsker å reparere skaden(e), trykk på knappen under og vi tar kontakt med deg for å sette opp en passende dato. Vi beregner ca dager for reparasjonen.\n\nVi tar forbehold om at skaden er mer komplisert enn hva bildene tilsier.\n\nHa en fin dag!"
				},
				{
					send_offer: 0,
					title: "Når en eller flere skader er for store",
					text: "Hei {{Navn}} - dette skal vi hjelpe deg med!\n\nVi har nå gått igjennom din sak og en eller flere av skadene lar seg dessverre ikke prise basert på bilder og må undersøkes fysisk på verkstedet slik at vi kan finne den mest effektive metoden for reparasjon.\n\nFlott om du har muligheten til å turen innom oss for en vurdering. En slik vurdering er gratis, drop-in og tar 5 minutter. Våre åpningstider er 0800-1600.\n\nTa kontakt med oss på tlf eller mail dersom det er noe du lurer på ☺\n\nHa en fin dag!"
				},
				{
					send_offer: 0,
					title: "Når ingen av skadene kan prises",
					text: "Hei {{Navn}} - dette skal vi hjelpe deg med!\nVi har nå gått igjennom din sak og skaden(e) lar seg dessverre ikke prise basert på bilder og må undersøkes fysisk på verkstedet slik at vi kan finne den mest effektive metoden for reparasjon.\n\nFlott om du har muligheten til å turen innom oss for en vurdering. En slik vurdering er gratis, drop-in og tar 5 minutter. Våre åpningstider er 0800-1600.\n\nTa kontakt med oss på tlf eller mail dersom det er noe du lurer på☺"
				}
			],
			isOfferFormActive: false,
			previousOfferForm: ""
		}
	},
	computed: {
		hideNavigation() {
			return this.$route.name == 'request' && this.$route.params.type != 'admin';
		},
		offerComment: {
			get: function () {
				if (this.$route.params.type == 'admin') {
					if (this.newComment) {
						return this.newComment;
					} else {
						return this.offerText ? this.offerText.text.replace(/\{\{Navn\}\}/i, this.getFirstName()) : '';
					}
				}
			},
			set: function (newValue) {
				this.newComment = newValue;
			}
		},
		workshop: {
			get: function () {
				for (var i = 0; i < this.workshops.length; i++) {
					var workshop = this.workshops[i];
					if (workshop.id == this.request.id_workshop)
						return workshop
				}
				return null
			},
			set: function (workshop) {
				if (workshop)
					this.$store.commit('setItem', {type: 'request', item: 'id_workshop', val: workshop.id})
				else
					this.$store.commit('setItem', {type: 'request', item: 'id_workshop', val: null})
			}
		},
		companies(){
			return this.$store.getters.companies
		},
		car() {
			return this.$store.getters.car
		},
		damages() {
			return this.$store.getters.damages
		},
		contact() {
			return this.$store.getters.contact
		},
		request() {
			return this.$store.getters.request
		},
		requestErrors() {
			var self = this;

			if (self.validate) {
				var e = {};

				if (!self.contact.name) {
					e.contact_name = 'Fornavn / Etternavn må fylles ut';
				}

				if (!self.contact.address) {
					e.contact_address = 'Adresse må fylles ut';
				}

				if (!self.contact.email || !self.contact.email.match(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/ig)) {
					e.contact_email = 'Gyldig e-post må fylles ut';
				}

				if (!self.contact.phone || !self.contact.phone.match(/^\d{8}$/ig)) {
					e.contact_phone = 'Mobilnummer må fylles ut (8 siffer)';
				}

				if (!self.contact.company) {
					e.contact_company = 'Firma må fylles ut';
				}

				if (!self.request.car_id) {
					e.car_id = 'Registreringsnummer må fylles ut';
				} else {
					if (!self.request.car_id.match(/^[A-Za-z]{2}\d{5}$/ig) && !self.request.car_id.match(/^[A-Za-z]{3}\d{3}$/ig)) {
						e.car_id = 'Registreringsnummer skal være som AB00000 or ADB000';
					}
				}

				if (!self.request.mileage) {
					e.mileage = 'Kilometerstand må fylles ut';
				}

				if (!self.request.damage_date) {
					e.damage_date = 'Skadedato må fylles ut';
				}

				if (!self.request.insurance_company) {
					e.insurance_company = 'Forsikrings selskap må velges';
				}

				if (1 !== Number(self.request.consent)) {
					e.consent = 'Dette feltet er obligatorisk';
				}

				if (1 !== Number(self.request.consent_second)) {
					e.consent_second = 'Dette feltet er obligatorisk';
				}

				return e;
			} else {
				return {};
			}
		}
	},
	methods: {
		toggleDamageContentView(damageIndex) {
			let activeStatus = this.$root.damages[damageIndex].active;

			if (null === activeStatus && damageIndex === 0) {
				this.$root.damages[damageIndex].active = false;
			} else if (null === activeStatus) {
				this.$root.damages[damageIndex].active = true;
			} else {
				this.$root.damages[damageIndex].active = !activeStatus;
			}

		},
		isAddedByWorkshop() {
			let id_user = parseInt(this.request.id_user);
			let id_workshop = parseInt(this.request.id_workshop);
			return id_user && id_workshop && id_user == id_workshop;
		},
		isActiveOfferService() {
			return this.workshop && (parseInt(this.workshop.status) >= 15)
		},
		offerFormIsNeeded() {
			return this.$route.params.type == 'admin' && (!this.$root.request.offer_date || this.$root.isOfferFormActive) && this.$root.isActiveOfferService()
		},
		autoReplyChange(val, damage) {
			damage.offer_text = val;
			if (!(parseFloat(damage.offer_price) > 0)) {
				if (val) {
					damage.offer_price = 0;
				} else {
					damage.offer_price = null;
				}
			}
			return true;
		},
		getCarModel: function () {
			var self = this;

			var re = /[^\d\w]/gi;
			var license = self.request.car_id ? self.request.car_id.replace(re, '') : self.request.car_id;

			if (!license || (!license.match(/^\w{2}\d{5}$/) && !license.match(/^\w{3}\d{3}$/))) {
				return;
			}

			self.$root.ui.loading = true;
			self.$api.getCarModel(license).then(data => {
				console.log(data);
				self.$root.ui.loading = false;
				self.$store.commit('set', {type: 'car', val: data})
			})
		},
		isRequestFinished() {
			return this.$root.request.finished_at;
		},
		isOfferConsidered() {
			return this.request.offer_consideration_date && parseInt(this.request.offer_status);
		},
		isOfferConfirmed() {
			return this.$root.request.offer_consideration_date && parseInt(this.$root.request.offer_status) === 1;
		},
		isOfferRejected() {
			return this.$root.request.offer_consideration_date && parseInt(this.$root.request.offer_status) === -1;
		},
		isOfferNeedConsideration() {
			let offer_status = parseInt(this.$root.request.offer_status)
			return this.$root.request.offer_date && !this.$root.request.offer_consideration_date && !(offer_status || offer_status === 0);
		},
		isOfferNeedReconsideration() {
			return this.$root.request.offer_consideration_date && parseInt(this.$root.request.offer_status) === 0;
		},
		isNoPriceOffer() {
			let offer_status = parseInt(this.$root.request.offer_status)
			return this.$root.request.offer_date && !this.$root.request.offer_consideration_date && offer_status == -2
		},
		customDateFormat(dateStr) {
			return dateStr.replace(/^(\d{4})\-(\d{2})\-(\d{2})\s(\d{2}):(\d{2}):(\d{2})$/, (match, year, month, day, hour, minute) => {
				return day + "." + month + "." + year + " " + hour + ":" + minute;
			});
		},
		toDamages: function (checkCarModel) {
			var self = this;
			if (self.$root.redirect) {
				let url = self.$root.redirect;
				if (checkCarModel && self.$root.request.car_id) {
					url += '/#/' + self.$root.request.car_id;
				} else {
					url += '/#/damages/1';
				}
				location.href = url;
				return;
			}
			console.log(checkCarModel);
			if (checkCarModel) {
				self.$root.getCarModel();
			}
			self.$router.push({name: 'damage-item', params: {id: 1}});
		},
		addImage: function (file, damageIndex) {
			var self = this;

			var fileId = self.files.push({
				url: file.dataUrl,
				file: dataURLtoBlob(file.dataUrl),
				name: file.info.name
			}) - 1;

			damageIndex = (damageIndex || damageIndex === 0) ? damageIndex : (self.$route.params.id - 1);

			self.$root.damages[damageIndex].images.push(fileId);

			console.log(self.$root.damages);
			console.log(self.files);
		},
		onStartUploadImage: function () {
			this.$root.ui.loading = 'uploadFile';
		},
		onCompleteUploadImage: function () {
			this.$root.ui.loading = false;
		},
		removeDamage: function (damageIndex) {
			var self = this;
			if (self.$root.damages.length < 2)
				return;
			if (self.$route.name == 'damage-item-bug' && self.$root.damages[damageIndex].id)
				return;

			var damage = self.$root.damages[damageIndex];
			damage.images.forEach(function (item, i, arr) {
				delete self.$root.files[item];
			});

			self.$root.damages.splice(damageIndex, 1);
			this.$router.push({name: this.$route.name, params: {id: self.$root.damages.length}});
		},
		modelClick: function (e) {
			this.damages[this.$route.params.id - 1].position = {
				top: (e.layerY / e.target.clientHeight * 100).toFixed(2),
				left: (e.layerX / e.target.clientWidth * 100).toFixed(2),
			}
		},
		addDamage: function () {
			// if (!this.$root.validateDamages()) return;

			var newDamageObject = newDamage;

			newDamageObject.active = true;

			var newDamageIndex = this.damages.push(JSON.parse(JSON.stringify(newDamageObject)));
			this.$router.push({name: this.$route.name, params: {id: newDamageIndex}});

			// $("html, body").animate({scrollTop: $("#damages .preview-wrap").last().offset().top}, "slow");
		},
		submitDamages: function () {
			let self = this;
			if (this.$route.name == 'damage-item-bug') {
				return this.$root.updateDamages();
			}
			if (this.$root.isAdminPage()) {
				this.$root.sendRequest();
			} else if (this.$root.isWennApiPage()) {
				this.$root.sendPreRequest().then(function (data) {
					self.request.id = data.id;
					self.$router.push({name: 'auto-offer'})//, params: {code: data.code}
				});
			} else {
				if (!this.validateDamages()) return;
				this.$router.push({name: 'contact'})
			}
		},
		validateDamages: function () {
			var self = this, imagesCount = 0;

			for (var i = 0; i < self.damages.length; i++) {
				var damage = self.damages[i];
				// i !== 7 prevent check documents
				if (damage.images.length && i !== 7) {

					imagesCount = imagesCount + damage.images.length;

					if (2 > damage.images.length) {
						self.showModal('Du må laste opp minst 2 bilder av skaden');

						if (self.$route.name == 'damage-item-bug')
							self.$router.push({name: 'damage-item-bug', params: {id: i + 1}});
						else
							self.$router.push({name: 'damage-item', params: {id: i + 1}});

						var previewEl = $("#damages .damage-item").eq(i);
						if (previewEl.length) {
							$("html, body").animate({scrollTop: previewEl.offset().top}, "slow");
						}

						return false;
					}
				}
			}

			if (2 > imagesCount) {
				self.showModal('Du må laste opp minst 2 bilder av skaden');
				return false;
			}

			return true;
		},
		validateContact: function () {

			console.log("validate Contact");

			if (Object.keys(this.requestErrors).length) {
				this.$router.push({name: 'contact'});

				return false;
			}

			return true;
		},
		removeImage: function (imgIndex, damageIndex) {
			damageIndex = (damageIndex || damageIndex === 0) ? damageIndex : (this.$route.params.id - 1);

			var fileId = this.damages[damageIndex].images[imgIndex];
			this.damages[damageIndex].images.splice(imgIndex, 1);
			delete this.files[fileId];
		},
		extendContact(data) {

			var contact = this.contact;

			for (var prop in data) {
				if (!contact[prop])
					contact[prop] = data[prop];
			}
		},

		updateConsent: function () {
			var self = this;
			var contact = self.contact;
			console.log(contact);

			var consent = 0;
			if (self.$root.contact.codan_consent) {
				consent = 1;
				contact.codan_consent = 1;
			} else {
				contact.codan_consent = 0;
			}
			console.log(contact);

			self.$root.ui.loading = true;

			//consent
			return self.$api.updateConsent(contact).then(data => {
				self.$root.ui.loading = false;
			})
		},
		getContact: function () {
			var self = this;
			var contact = self.contact;
			var phone = contact.phone.replace(/[^\d]/gi, '');

			if (!phone.match(/^\d{8}$/gi)) return;

			self.$root.ui.loading = true;
			return self.$api.getContact(phone).then(data => {
				self.$root.ui.loading = false;

				self.extendContact(data);
			})
		},
		validateRequest: function (onlyContact = false) {
			this.validate = true;

			return ((onlyContact || this.validateDamages()) && this.validateContact());
		},
		formatDate(dtStr, showTime, showYear) {
			if (!dtStr) return ''
			var monthNames = [
				"Januar", "Februar", "Mars",
				"April", "Mai", "Juni",
				"Juli", "August", "September",
				"Oktober", "November", "Desember"
			];

			var dt = new Date(dtStr.replace(/-/g, "/"))

			var time = ''
			if (showTime)
				time = ' ' + dt.getHours().toString().replace(/^([0-9])$/, '0$1') + ':' + dt.getMinutes().toString().replace(/^([0-9])$/, '0$1')

			var res = dt.getDate() + '. ' + monthNames[parseInt(dt.getMonth())];
			if (showYear)
				res = res + ' ' + dt.getFullYear();
			res = res + ' kl ' + time

			return res;
		},
		submitContact: function () {
			var self = this;

			if (self.$root.isAdminPage()) {
				if (!self.validateRequest(true)) {
					return;
				} else {
					self.$router.push({name: 'damage-item', params: {id: 1}});
				}
			} else {
				if (!self.validateDamages()) {
					self.$router.push({name: 'damage-item', params: {id: 1}});
				} else {
					self.$root.sendRequest()
				}
			}
		},
		getFirstName() {
			if (!(this.contact && this.contact.name))
				return '';
			let pieces = this.contact.name.split(" ");
			return pieces[0];
		},
		sendGACreateEvent() {
			function checkGa() {
				var scripts = document.getElementsByTagName('script'),
					ga = true, // set to false if you don't want to check for ga.js
					ua = true, // set to false if you don't want to check for analytics.js
					dc = false, // set to false if you don't want to check for dc.js
					len = 0,
					i = 0;

				if (ga || ua || dc) {
					for (i, len = scripts.length; i < len; i += 1) {
						if (ga && /www\.google-analytics\.com\/ga\.js/.test(scripts[i].src)) {
							return true;
						}
						if (ua && /www\.google-analytics\.com\/analytics\.js/.test(scripts[i].src)) {
							return true;
						}
						if (dc && /stats\.g\.doubleclick\.net\/dc\.js/.test(scripts[i].src)) {
							return true;
						}
					}
				}
				return false;
			}

			if (checkGa()) {
				if (this.$root.insuranceFleetCompany) {
					console.log('Tracking Insurance Fleet');
					ga('gtm4.send', {
						hitType: 'event',
						eventCategory: 'Inquiry',
						eventAction: 'Submit',
						eventLabel: 'Insurance'
					});
					fbq(
						'track',
						"CompleteRegistration",
						'{content_name: "Inquiry Insurance", status: "submited"}'
					);
				} else if (this.$root.fleetCompany) {
					console.log('Tracking Fleet');
					ga('gtm4.send', {
						hitType: 'event',
						eventCategory: 'Inquiry',
						eventAction: 'Submit',
						eventLabel: 'Fleet',
					});
					fbq(
						'track',
						"CompleteRegistration",
						'{content_name: "Inquiry Fleet", status: "submited"}'
					);
				} else {
					console.log('Tracking Regular');
					ga('gtm4.send', {
						hitType: 'event',
						eventCategory: 'Inquiry',
						eventAction: 'Submit',
						eventLabel: 'Website',
					});
					fbq(
						'track',
						"CompleteRegistration",
						'{content_name: "Inquiry", status: "submited"}'
					);
				}
			}
		},
		updateDamages: function () {

			console.log("sending");

			var self = this;
			if (!self.validateRequest()) return;

			console.log("validated");

			var data = {
				request: self.request,
				damages: self.damages.map(function (d) {
					return {
						id: d.id,
						id_request: d.id_request,
						position: d.position,
						images: d.images.map(function (i) {
							if (self.$root.files[i].file)
								return i;
							else
								return self.$root.files[i].url;
						})
					}
				}),
				code: self.$route.params.code
			}

			self.$root.ui.loading = true;

			return self.$api.updateDamages(data, self.files).then(data => {
				self.$root.ui.loading = false;
				if (!data)
					return;

				if (self.$root.isAdminUser() || self.$root.isAdminPage() || self.$route.params.type == 'admin') {
					self.$router.push({name: 'request', params: {type: 'admin', code: data.code}});
				} else {
					self.$router.push({name: 'request', params: {type: 'client', code: data.code}});
				}

				self.validate = false;
			})
		},
		sendPreRequest: function () {
			var self = this;
			if (!self.validateRequest()) return;

			var data = {
				car: self.car,
				request: self.request,
				damages: self.damages
			}

			self.$root.ui.loading = true;

			return self.$api.sendRequest(data, self.files).then(data => {
				self.$root.ui.loading = false;
				self.validate = false;
				return data;
			})
		},
		sendRequest: function () {

			console.log("sending request");

			var self = this;
			if (!self.validateRequest()) return;

			self.$root.ui.loading = true;

			var request = self.request,
				contact = self.contact;

			request.contact_name = contact.name;
			request.contact_phone = contact.phone;
			request.contact_email = contact.email;
			request.address = contact.address;
			request.contact_company = contact.company;
			request.date = new Date();
			request.consent = parseInt(request.consent) ? true : false;
			request.consent_second = parseInt(request.consent_second) ? true : false;

			const currentUrl = window.location.href;

			// Create a URL object based on the current URL
			const url = new URL(currentUrl);

			// Check if 'circlek' is part of the pathname
			const hasCircleKInPath = url.pathname.includes('circlek');

			if ( hasCircleKInPath ) {
				request.circlek = true
			}


			var prepareData = {
				request: request,
				damages: self.damages
			}

			return self.$api.sendRequest(prepareData, self.files).then(data => {
				if (data.id) {
					self.$root.ui.loading = false;
					self.$root.ui.thanks = true;
				}
			})
		},
		newRequest() {
			let url = location.pathname;
			if (this.$root.isAdminPage())
				url += "#/opq";
			location.href = "//" + location.hostname + url;
			//location.reload(true);
		},
		runWorkshopsMailingReminder(continue_flag = true) {
			var self = this;
			if (!continue_flag)
				return false;
			return self.$http.get('/wp-admin/admin-ajax.php?action=mps_opq_workshops_mailing_reminder').then(resp => {
				return self.runWorkshopsMailingReminder(resp.body.data.continue)
			}, resp => {
				return null
			})
		},
		runOffersMailingReminder(continue_flag = true) {
			var self = this;
			if (!continue_flag)
				return false;
			return self.$http.get('/wp-admin/admin-ajax.php?action=mps_opq_offers_mailing_reminder').then(resp => {
				return self.runOffersMailingReminder(resp.body.data.continue)
			}, resp => {
				return null
			})
		}
	},
	created: function () {
		var self = this;
		if (self.$root.isAdminPage() && !self.$root.getCookie('mpsWorkshopsReminderOff'))
			self.runWorkshopsMailingReminder()
		if (self.$root.isAdminPage() && !self.$root.getCookie('mpsOffersReminderOff'))
			self.runOffersMailingReminder()

		//self.$api.getWorkshops().then(self.resolveWorkshops)
	}
}
export default mixin


// WEBPACK FOOTER //
// ./requests/assets/src/mixins/request.js